export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8703.8b5722a9.jpg";